import React, { useEffect, useRef, useState } from 'react'
import BaseDialog from 'components/dialog'
import ButtonBase from 'components/partials/button'
import Moment from 'react-moment'
import moment from 'moment'
import Loading from 'react-loading'
import EditableListInline from '../editable-phone'
import { useLazyQuery, useMutation } from '@apollo/client'
import { GET_CHAT_TEXT_QUERY, LOAD_DOCUMENT_CONTENT, SEND_CHAT_MESSAGES } from 'queries/adminPortal'
import Select from 'react-select'

export interface IMessageDetailItem {
  sender: string
  receiver: string
  text: string
  timestamp: Date
  status: string
  id: string
  isUserSendSMS: boolean
}

export interface ISMSTemplateFile {
  id: string
  name: string
}

interface PropsAction {
  modalIsOpen?: boolean
  smsTemplates: ISMSTemplateFile[]
  title: string
  handleCloseDialog?: (val?: boolean) => void
  userNumber: string
}

const styleDetailItem = {
  content: {
    width: '90%',
    maxWidth: '800px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    borderRadius: '16px',
    boxShadow: '8px 11px 21px 0px rgba(148,144,144,0.75)',
    background: '#fdfdfd',
    height: '100vh'
  },
}
const ChatContentItemDialog: React.FunctionComponent<PropsAction> = ({
  userNumber,
  modalIsOpen,
  title,
  smsTemplates,
  handleCloseDialog = () => null,
}) => {
  const [
      loadingDocumentContent,
    ] = useLazyQuery(LOAD_DOCUMENT_CONTENT)
  const [
    getChatMessage,
  ] = useLazyQuery(GET_CHAT_TEXT_QUERY)
  const handleCloseButton = () => {
    setChatMessages([])
    handleCloseDialog(isReloadTxtList)
  }

  const [sendChatMessages] = useMutation(SEND_CHAT_MESSAGES)

  const loadChatMessages = async (phoneNumber: string) => {
    const variables = {
      phoneNumber: phoneNumber,
      skip: 0,
      take: 20,
    }
    setLoadingChatMessage(true)
    getChatMessage({
      variables,
      fetchPolicy: 'network-only',
    }).then((result) => {
      setLoadingChatMessage(false)
      setChatMessages(result.data.getChatMessageForPhoneNumber)
    }).finally(() => {
      setReloadInput(!isReloadInput)
    })
  }

  const handleOnchangeDocumentId = (documentId: string) => {
    if (documentId !== '') {
      setReloadInput(!isReloadInput)
      setPlaceholderMessage('Loading template')
      const variables = {
        documentId: documentId,
        phoneNumber: listPhones.length === 1 ? listPhones[0] : undefined
      }
      loadingDocumentContent({
        variables,
        fetchPolicy: 'network-only',
      }).then((result) => {
        setPlaceholderMessage('Type a message')
        if (inputRef.current) {
          inputRef.current.value = result.data.loadDocumentContent
        }
        setInput(result.data.loadDocumentContent)
      })
    } else {
      setPlaceholderMessage('Type a message')
    }
  }

  const handleChangePhoneNumbers = (phones: string[]) => {
    setListPhone(phones)
  }

  const handleSendChatMessages = async (phoneNumbers: string[], msg: string): Promise<string> => {
    if (phoneNumbers.length === 0) {
      return ''
    }
    const result = await sendChatMessages({
      variables: { 
        input: {
          sendToPhone: phoneNumbers,
          msg
      }},
      fetchPolicy: 'network-only',
    })
    setReloadTxtList(true)
    return result.data?.sendChatMessages || ''
  }

  const getStatusIcon = (status: string) => {
    switch(status) {
      case 'send':
        return '📤'
      case 'delivered':
        return '✅'
      default:
        return `❗`
    }
  }
  const handleButtonSendMessage = async () => {
    if (listPhones.length <= 0) {
      return
    }
    if (input !== '') {
      const array = new Uint32Array(1)
      window.crypto.getRandomValues(array)
      setLoadingChatMessage(true)
      await handleSendChatMessages(listPhones, input)
      await loadChatMessages(listPhones[0])
      
    }
  }
  const chatRef = useRef<HTMLDivElement>(null)
  const [chatMessages , setChatMessages] = useState<IMessageDetailItem[]>([])
  const [input, setInput] = useState('')
  const [isReloadInput, setReloadInput] = useState(false)
  const [placeholderMessage, setPlaceholderMessage] = useState('Type a message')
  const [listPhones, setListPhone] = useState(userNumber ? [userNumber] : [])
  const [isLoadingChatMessage , setLoadingChatMessage] = useState<boolean>(false)
  const [isReloadTxtList , setReloadTxtList] = useState<boolean>(false)
  const inputRef = useRef<HTMLTextAreaElement>(null)
  useEffect(() => {
    
    setTimeout(() => {
      if (chatMessages.length > 0 && chatRef.current) {
        chatRef.current.scrollTop = chatRef.current.scrollHeight
      }
    }, 100)
  }, [chatMessages, isLoadingChatMessage])

   useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = ''
    }
    setInput('')
   }, [isReloadInput])
  
  useEffect(() => {
    if (userNumber) {
      loadChatMessages(userNumber)
    }
  }, [userNumber])
  return (
    <BaseDialog modalIsOpen={modalIsOpen} customStyles={styleDetailItem}>
      <div className="w-[758px] p-1 pr-0" >
        <EditableListInline 
          handleOnChangeItems={handleChangePhoneNumbers}
          listItem={listPhones} 
          title=''
          placeholder='Add new Phone'/>
        <hr className="mt-3 mb-5 mr-1 border-neutral-5" />
        <div className="flex flex-col bg-gray-100 h-[600px]">
          <div id="chat-feed"  ref={chatRef} className="flex-1 overflow-y-auto p-4 space-y-2">
              {chatMessages && chatMessages.length > 0 && chatMessages.map((msg) => {
                const isOutbound = !msg.isUserSendSMS
                return (
                  <div
                    key={msg.id}
                    className={`flex ${isOutbound ? 'justify-end' : 'justify-start'}`}
                  >
                    <div
                      className={`max-w-xs sm:max-w-sm md:max-w-md px-4 py-2 rounded-lg shadow ${
                        isOutbound
                          ? 'bg-blue-500 text-white rounded-br-none'
                          : 'bg-gray-200 text-gray-900 rounded-bl-none'
                      }`}
                    >
                      <p className="text-sm break-words whitespace-pre-line">{msg.text}</p>
                      <div className="flex items-center justify-end mt-1 text-xs text-white/80">
                        <Moment format="yyyy-MM-DD HH:mm">
                          {moment.utc(msg.timestamp ?? '')} 
                        </Moment>
                        <span>{isOutbound && getStatusIcon(msg.status)}</span>
                      </div>
                    </div>
                  </div>
                )
              })}
              {isLoadingChatMessage && <div className='flex justify-end'>
                  <Loading color='bg-blue-500' className="relative py-6" height={30} width={30} />
                </div>}
            </div>

            {/* Message Input */}
          <div className="bg-white p-4 border-t flex items-center space-x-2 h-[200px]">
              <textarea
                onChange={(evt) => { 
                  setInput(evt.target.value) 
                }}
                ref={inputRef}
                id="chatInputMessage"
                placeholder={placeholderMessage}
                className="resize-none h-full  flex-1 px-4 py-2 border focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
              {/* <button className="px-4 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600"
                onClick={() => {
                  handleButtonSendMessage()
                }}>
                Send
              </button> */}
              
          </div>
        </div> 
        <div className='flex items-center justify-between mb-3'>
          <Select
            options={smsTemplates.map((item) => ({
              value: item.id,
              label: item.name
            }))}
            onChange={(newValue) => handleOnchangeDocumentId(newValue?.value || '')}
            menuPlacement='top'
            className='ml-3 w-full max-w-md'
            placeholder='Document Template Id'
            />
          <div className='flex items-end space-x-4'>
            <ButtonBase
            type="submit"
            disabled={isLoadingChatMessage}
            className="w-[150px] my-4 ml-3 justify-around border-2 border-primary-1 focus:outline-none focus:ring-2 focus:ring-blue-400"
            onClick={() => {
              handleButtonSendMessage()
            }}
          >
            Send
          </ButtonBase>
          <ButtonBase
            type="submit"
            className="w-[150px] my-4 ml-3 justify-around border-2 border-primary-1 text-primary-1 bg-white-50 hover:bg-primary-shade4"
            onClick={() => {
              handleCloseButton()
            }}
            bgDisabled="bg-primary-shade3"
          >
            Close
          </ButtonBase>
          </div>
        </div>
        
        
       
      </div>
    </BaseDialog>
  )
}

export default ChatContentItemDialog
